module.exports = __webpack_public_path__ + "static/media/container_img.6210fa34.jpg";